import { useEffect, useRef } from 'react';

export const useIdleTimeout = (timeoutMinutes: number = 30) => {
    const timeoutId = useRef<NodeJS.Timeout | null>(null);

    const resetTimeout = () => {
        if (timeoutId.current) clearTimeout(timeoutId.current);

        // Convert minutes to milliseconds
        timeoutId.current = setTimeout(() => {
            // Trigger the same event the API interceptor uses
            window.dispatchEvent(new CustomEvent('session-expired'));
        }, timeoutMinutes * 60 * 1000);
    };

    useEffect(() => {
        // Events that indicate the user is active
        const events = ['mousemove', 'keydown', 'mousedown', 'touchstart', 'scroll'];

        const handleActivity = () => resetTimeout();

        // Attach listeners
        events.forEach(event => window.addEventListener(event, handleActivity));

        // Start the initial timer
        resetTimeout();

        return () => {
            events.forEach(event => window.removeEventListener(event, handleActivity));
            if (timeoutId.current) clearTimeout(timeoutId.current);
        };
    }, [timeoutMinutes]);
};